var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "noviceGuidance" },
    [
      _vm._l(_vm.list, function (item, i) {
        return [
          _vm.index === i
            ? _c(
                "div",
                {
                  key: i,
                  staticClass: "posit",
                  style: { left: item.left, top: item.top },
                },
                [
                  _c(
                    "div",
                    { class: ["item", item.arrowClass ? item.arrowClass : ""] },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(item.title)),
                      ]),
                      item.tips
                        ? _c("div", { staticClass: "tips" }, [
                            _vm._v(_vm._s(item.tips)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "msg" }, [
                        _vm._v("通过文字描述来生成各种图片。"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "bottom_row" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "next",
                              attrs: { type: "primary" },
                              on: { click: _vm.next },
                            },
                            [_vm._v(" 我知道了 ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }